import { ChevronDown } from 'lucide-react';
import { useId, type ReactNode } from 'react';

interface Props {
  /** What the panel holds, e.g. "Câmeras". */
  label: string;
  /** What is chosen now, shown beside the label while closed. */
  summary?: string | undefined;
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
}

/**
 * A panel that sits above the main content on phones (a camera list above
 * the video) and closes once something is chosen, so the video stays in
 * view. From the lg breakpoint it is always open beside the content and the
 * toggle is hidden.
 */
export function PhoneCollapse({ label, summary, open, onToggle, children }: Props) {
  const id = useId();
  return (
    <>
      <button
        type="button"
        aria-expanded={open}
        aria-controls={id}
        onClick={onToggle}
        className="flex h-11 w-full items-center gap-2 rounded-md border border-line bg-surface px-3 text-left text-[13px] text-fg lg:hidden"
      >
        <span className="font-medium">{label}</span>
        {summary && <span className="min-w-0 flex-1 truncate text-fg-muted">· {summary}</span>}
        <ChevronDown
          aria-hidden="true"
          className={`ml-auto size-4 shrink-0 text-fg-subtle transition-transform ${open ? 'rotate-180' : ''}`}
        />
      </button>
      <div id={id} className={`flex min-h-0 flex-col gap-2 ${open ? '' : 'hidden lg:flex'}`}>
        {children}
      </div>
    </>
  );
}
